import { Box } from '@mui/material';
import React from 'react';
import FirmitasByFidesLockup from '../FirmitasByFidesLockup';

/** The platform brand in the admin header; the investor portal's counterpart renders nothing. */
const HeaderBrandLockup: React.FC = () => (
  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
    <FirmitasByFidesLockup />
  </Box>
);

export default HeaderBrandLockup;
